import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { initState, PrizesData } from './types';

const initialState: initState = {
  list: {
    data: [],
    meta: {
      totalCount: 0
    },
  },
};

const prizesSlice = createSlice({
  name: 'prizes',
  initialState,
  reducers: {
    setPrizesData(state: initState, action: PayloadAction<{ list: PrizesData }>) {
      state.list = action.payload.list;
    },
  },
});

export const { setPrizesData } = prizesSlice.actions;

export default prizesSlice.reducer;
